var map = {
	"./Dr. Senthil Kumar Kandasamy has received Ten lakh in funding under the prestigious PATHFINDER program - 2025.JPG": 39532,
	"./Dr.A.Manimaran - NSS Programme Officer in Kongu Engineering College Perundurai received the Best NSS Programme Officer award for the year - 2023.jpg": 87077,
	"./Dr.A.Muthusamy(CT UG) received First Prize in Excellence in Research and Publication Award-2024.jpg": 75000,
	"./Dr.D.ramya(English) received Best Professor Award - 2024 by Silampoli Foundation.jpg": 222,
	"./Dr.G.S.Rampradheep received 2020 Concrete Projects Competition Award Winner from ACI USA - 28.03.2020.jpg": 33531,
	"./Dr.G.S.Rampradheep received IEI Young Engineer Award - 07.12.2020.jpg": 69959,
	"./Dr.J.Rajini received NPTEL Discipline Star Award - 2025.jpg": 48897,
	"./Dr.P.Karthikeyan(MBA) received Best Faculty award in Excellence in Research and Publication-2024.jpg": 80578,
	"./Dr.S.Vijayachitra(EIE) received National Best Women Teacher award from Punjab Governor-2025.jpg": 26399,
	"./Dr.T.Geetha received Best Educator Award - 2025.jpg": 38128,
	"./Dr.T.P.Sathish Kumar - Mechanical Engineering of KEC Listed among the Top Indian Researchers in Worldwide Scientists Database 2021.jpg": 47330,
	"./Dr.V.Hariharan - Professor in Mechanical Engineering Department received the ISTE- PERIYAR AWARD FOR BEST ENGINEERING COLLEGE TEACHER for the year 2023.jpg": 20790,
	"./Dr.V.Hariharan - Professor of Mechanical Engineering received ISTE Best Student Chapter Faculty Advisor Award for the year 2021.jpg": 95493,
	"./Flg Offr. A.Jeevanantham received DDG (Deputy Director General) Appreciation Card-2024.jpg": 81572,
	"./Major Dr. P.S. Raghavendran NCC Officer of Kongu Engineering College Bagged the Directorate General Commendation Award 2022.png": 73497,
	"./Ms.S.Vijayashanthy - Assistant Professor of Civil Engineering received ISTE Best Student Chapter Faculty Advisor Award for the year 2021.jpg": 63349,
	"./NCC Flying Officer Jeevanantham of KEC Received First in Order of Merit Award in National Level Pre Commission Training Course 2021.jpg": 68714,
	"./Received Best Academic Researcher award from Mercury publications Consortium - 20.12.2020.jpg": 85991,
	"./Received Best Innovator Award - Ulzavan 2020 Awards - 17.01.2020.jpg": 63519,
	"./Received Best Performing Associate NCC Officer  Caretaker Award - 11.12.2020.jpg": 33694,
	"./Received Certificate of Recognition from IEEE - 16.12.2020.jpg": 75232,
	"./Received INNOVATIVE RESEARCHER AWARD from IET - 26.12.2020.jpg": 49702,
	"./Received SYMACHARYA award from Symbiosis Centre for Management Studies, Noida - 21.02.2020.jpg": 76774,
	"./Received THANGA MANGAI AWARD for Excellence in Women Education - Platinum Category 2024.jpg": 84482,
	"./Received longest Student Branch Coordinator award from Computer Society of India - 18.01.2020.jpg": 25928,
	"./Recognized as MENTOR FOR CHANGE from ATAL INNOVATION MISSION - 20.02.2020.jpg": 44567,
	"./V. Sudhir Kumar received  Event Champion Award - 2025.jpeg": 51978,
	"./V.Priyanka   received Best Educator Award - 2025.jpg": 49341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99816;